/** Reserved documentation hosts cannot contain imported media. */
export function unavailableMediaUrl(value: string): boolean {
  try {
    const url = new URL(value, "https://media.local");
    const host = url.hostname.toLowerCase().replace(/\.$/u, "");
    return (
      !["http:", "https:"].includes(url.protocol) ||
      /(?:^|\.)(?:example|invalid)$/u.test(host)
    );
  } catch {
    return true;
  }
}
